
    import {
      getAllStaffRequirementSubmissions,
      createStaffRequirementSubmission,
      createAllStaffRequirementSubmissions,
      updateStaffRequirementSubmission,
      deleteStaffRequirementSubmission
    } from "@/services/staffRequirementSubmission";

    const state = {
      staffRequirementSubmissions: [],
      processed: false
    };

    const getters = {
      getStaffRequirementSubmissions(state) {
        return state.staffRequirementSubmissions;
      },
      staffRequirementSubmissionProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchStaffRequirementSubmissions({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllStaffRequirementSubmissions(
              params
            )
              .then(response => {
                commit("SET_STAFFREQUIREMENTSUBMISSIONS", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createStaffRequirementSubmission({ commit }, staffRequirementSubmission) {
          return new Promise((resolve, reject) => {
            createStaffRequirementSubmission(staffRequirementSubmission)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllStaffRequirementSubmissions({ commit }, staffRequirementSubmissions) {
          return new Promise((resolve, reject) => {
            createAllStaffRequirementSubmissions(staffRequirementSubmissions)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateStaffRequirementSubmission({ commit }, staffRequirementSubmission) {
          return new Promise((resolve, reject) => {
            updateStaffRequirementSubmission(staffRequirementSubmission)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteStaffRequirementSubmission({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteStaffRequirementSubmission(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_STAFFREQUIREMENTSUBMISSIONS(state, data) {
        state.staffRequirementSubmissions = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    